import member from './member'

export default model =>
`<ul class="MemberList">
  ${model.map(item).join("")}
</ul>`

const item = item => 
`<li class="MemberList-item">${member(item)}</li>`;


// WEBPACK FOOTER //
// ./scripts/templates/member-list.js